"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const OSWApptInfo_1 = __importDefault(require("./OSWApptInfo"));
exports.default = OSWApptInfo_1.default;
//# sourceMappingURL=index.js.map